import { BinService } from "@/common/api.service";
import {
  GET_BIN_LIST,
  DOWNLOAD_BIN_LIST,
  POST_BIN,
  GET_BIN_DETAILS,
  UPDATE_BIN,
  DELETE_BIN,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";

const state = {
  errors: null,
  bin_list: {},
};

const getters = {
  bin_list(state) {
    return state.bin_list;
  },
};

const actions = {
  async [GET_BIN_LIST](context, payload) {
    BinService.init();
    BinService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      BinService.get(`bin/list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          context.commit("setBinList", data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  async [DOWNLOAD_BIN_LIST](context, payload) {
    BinService.init();
    BinService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      BinService.get(`bin/download-csv${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Store Bin
  async [POST_BIN](context, payload) {
    BinService.init();
    BinService.setHeader();
    return new Promise((resolve) => {
      BinService.post(`bin/store`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get Bin Details
  async [GET_BIN_DETAILS](context, payload) {
    BinService.init();
    BinService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      BinService.get(`bin/detail/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Update Bin
  async [UPDATE_BIN](context, payload) {
    BinService.init();
    BinService.setHeader();
    return new Promise((resolve) => {
      BinService.put(`bin/update/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Delete Bin
  async [DELETE_BIN](context, payload) {
    BinService.init();
    BinService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      BinService.put(`bin/delete/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
  setBinList(state, data) {
    state.bin_list = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
